const destroyHandlers = Symbol('destroyHandlers')

export default {
  events: ['close'],

  mounted() {
    const onCloseFn = () => !this._disableClose && this.$emit('close')

    // Listening to mouse down to check where click originated, not where mouse ends up
    const handleMousedown = (event) => {
      const root = this.$refs?.root || this.$el
      if (!event.composedPath().includes(root) && !this._disableClose) {
        document.addEventListener('click', onCloseFn, { once: true })
      }
    }

    const handleKeydown = ({ key }) => {
      if (key === 'Escape') {
        onCloseFn()
      }
    }

    document.addEventListener('mousedown', handleMousedown)
    document.addEventListener('keydown', handleKeydown)

    this[destroyHandlers] = () => {
      document.removeEventListener('mousedown', handleMousedown)
      document.removeEventListener('keydown', handleKeydown)
    }
  },

  beforeDestroy() {
    this[destroyHandlers]()
  },
}
